<template>
  <div class="contents">
    <div class="list-box">
      <div class="err-msg-area">
        <p>
          <span
            v-for="e in serverErrors"
            :key="e"
            class="font_orange"
          >
            {{ e }}
          </span>
        </p>
      </div>

      <section
        v-for="group in deliveryTypeTables"
        :key="group.deliveryType"
      >
        <p class="delivery-type-area">
          <span class="font_orange">{{ group.title }}</span>
        </p>

        <p
          v-if="group.records.length === 0"
          class="unavailable-notice"
        >
          提供不可
        </p>

        <table
          v-else
          class="tbl"
        >
          <colgroup>
            <col
              v-for="n in 7"
              :key="n"
              style="width:10%;"
            />
          </colgroup>
          <tr>
            <th>申込時刻</th>
            <th
              v-for="(label, i) in WEEKDAY_LABELS"
              :key="i"
            >
              {{ label }}
            </th>
          </tr>
          <tr
            v-for="record in group.records"
            :key="record.id"
          >
            <td>
              <span>{{ record.wreq_time }}</span>
            </td>
            <td
              v-for="weekIdx in weekList"
              :key="weekIdx"
            >
              <OnetimePaymentCell
                :record="record"
                :week-index="weekIdx"
                @update="onCellUpdate"
                @disable="onCellDisable"
              />
            </td>
          </tr>
        </table>
      </section>
    </div>
  </div>
</template>

<script>
import { AdminPageType } from '@/consts/admin';
import { useAdminPageAccess } from '@/composables/useAdminPageAccess';
import adminOnetimePaymentApi from '@/api/adminOnetimePayment';
import OnetimePaymentCell from '@/components/Admin/components/OnetimePaymentCell.vue';
import { groupOnetimePaymentsByDeliveryType } from '@/utils/groupOnetimePaymentsByDeliveryType';

const WEEK_LIST = [1, 2, 3, 4, 5, 6];

const WEEKDAY_LABELS = ['月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日'];

const DELIVERY_TYPE_TITLE_MAP = new Map([
  [3, '当日'],
  [1, '翌日'],
  [2, '翌々日'],
]);

const DISPLAY_ORDER = [3, 1, 2];

export default {
  name: 'admin-onetime-payments',
  components: { OnetimePaymentCell },
  props: {
    adminType: {
      type: String,
      default: AdminPageType.ADMIN,
    },
  },
  data() {
    return {
      onetimePayments: [],
      weekList: WEEK_LIST,
      WEEKDAY_LABELS,
      serverErrors: [],
    };
  },
  computed: {
    deliveryTypeTables() {
      const grouped = groupOnetimePaymentsByDeliveryType(this.onetimePayments);
      return DISPLAY_ORDER.map((deliveryType) => ({
        deliveryType,
        title: DELIVERY_TYPE_TITLE_MAP.get(deliveryType) ?? '',
        records: grouped.get(deliveryType) ?? [],
      }));
    },
  },
  async mounted() {
    const { ensureManagerAccess } = useAdminPageAccess(this.adminType);
    const canAccess = await ensureManagerAccess();
    if (!canAccess) return;

    await this.loadOnetimePayments();
  },
  methods: {
    async loadOnetimePayments() {
      try {
        const { data } = await adminOnetimePaymentApi.index();
        this.onetimePayments = data.map((record) => ({
          ...record,
          wreq_time: record.wreq_time.slice(0, 5),
        }));
        this.serverErrors = [];
      } catch (e) {
        this.serverErrors = this.extractErrors(e);
      }
    },
    async onCellUpdate({ id, weekIndex, priceStr }) {
      try {
        await adminOnetimePaymentApi.update(id, { ['week' + weekIndex]: priceStr });
        await this.loadOnetimePayments();
      } catch (e) {
        this.serverErrors = this.extractErrors(e);
      }
    },
    async onCellDisable({ id, weekIndex }) {
      try {
        await adminOnetimePaymentApi.delete(id, { week: weekIndex });
        await this.loadOnetimePayments();
      } catch (e) {
        this.serverErrors = this.extractErrors(e);
      }
    },
    extractErrors(e) {
      const errRes = e?.response?.data?.errors;
      if (!errRes) return [];
      return Object.values(errRes).flat();
    },
  },
};
</script>

<style lang="scss" scoped>
.contents {
  width: 95%;
  margin: 20px auto 0;
  overflow-y: scroll;
  min-height: 400px;
}

.form-control {
  height: 24px;
  font-size: 12px;
  width: 96%;
}

.list-box {
  margin: 20px 0 0 0;

  .tbl {
    table-layout: fixed;
    font-size: 14px;
    border-collapse: collapse;
    vertical-align: middle;
    width: 100%;

    span {
      word-break: break-all;
    }
  }

  th, td {
    border: 1px solid #aaa;
    padding: 2px 4px;
  }
}

.delivery-type-area {
  background: #00a9ca;
  padding: 5px;
  margin-top: 15px;

  span {
    color: white;
    padding: 5px;
  }
}

.unavailable-notice {
  color: #c00;
  font-size: 14px;
  padding: 8px 0;
}
</style>
